import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
  Carousel,
  CarouselIndicators,
  CarouselItem,
} from "reactstrap";
import axios from "axios";

const items = [
  {
    src: "https://s3.amazonaws.com/creativetim_bucket/photos/110862/thumb.?1482812727",
    content: (
      <CardBody>
        <h5 className="card-description">
          "I'm newer to the front-end... With my creative side lacking in
          experience this really put me in the right spot to speed through the
          fast lane. I love this Design kit so much!"
        </h5>
        <CardFooter>
          <CardTitle tag="h4">Chase Jackson</CardTitle>
          <h6 className="card-category">Web Developer</h6>
          <div className="card-stars">
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star" />
          </div>
        </CardFooter>
      </CardBody>
    ),
    altText: "",
    caption: "",
  },
  {
    src: "https://s3.amazonaws.com/creativetim_bucket/photos/134607/thumb.?1487680276",
    content: (
      <CardBody>
        <h5 className="card-description">
          "Love the shapes and color palette on this one! Perfect for one of my
          pet projects!"
        </h5>
        <CardFooter>
          <CardTitle tag="h4">Robin Leysen</CardTitle>
          <h6 className="card-category">Web Developer</h6>
          <div className="card-stars">
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star" />
          </div>
        </CardFooter>
      </CardBody>
    ),
    altText: "",
    caption: "",
  },
  {
    src: "https://s3.amazonaws.com/creativetim_bucket/photos/125268/thumb.jpeg?1497799215",
    content: (
      <CardBody>
        <h5 className="card-description">
          "Love it. Use it for prototypes and along with Paper Dashboard."
        </h5>
        <CardFooter>
          <CardTitle tag="h4">Cristi Jora</CardTitle>
          <h6 className="card-category">Web Developer</h6>
          <div className="card-stars">
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star mr-1" />
            <i className="fa fa-star" />
          </div>
        </CardFooter>
      </CardBody>
    ),
    altText: "",
    caption: "",
  },
];

const myItems = [1, 1, 1, 1, 1, 1];

const RecentUpdates = () => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const [updates, setUpdates] = useState([]);

  useEffect(() => {
    getRecentUpdates();
  });

  const getRecentUpdates = async () => {
    const response = await axios.get(
      "https://swatch-v1.herokuapp.com/api/v1/recent_updates"
    );
    console.log(response);
    if (response.status === 200) {
      if (response.data.status === "success") {
      }
    }
  };

  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  return (
    <div className="section section-pricing cd-section" id="pricing">
      {/* ********* PRICING 1 ********* */}
      <div className="pricing-1 section">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="6">
              <h2 className="title">Recent Updates</h2>
              <h5 className="description">
                You have Free Unlimited Updates and Premium Support on each
                package.
              </h5>
            </Col>
          </Row>
          <div className="space-top" />

          <Row>
            <Col className="ml-auto mr-auto" md="12">
              <div className="page-carousel">
                <Carousel
                  activeIndex={activeIndex}
                  next={next}
                  previous={previous}
                >
                  <CarouselIndicators
                    items={items}
                    activeIndex={activeIndex}
                    onClickHandler={goToIndex}
                  />
                  {myItems.map((item) => {
                    return (
                      <CarouselItem
                        onExiting={onExiting}
                        onExited={onExited}
                        key={item.src}
                      >
                        <Row className="coloured-cards mx-auto ">
                          <Col md="4" sm="6">
                            <div className="card-big-shadow">
                              <Card
                                className="card-just-text"
                                data-background="color"
                                data-color="blue"
                                data-radius="none"
                              >
                                <CardBody>
                                  <h6 className="card-category">Best cards</h6>
                                  <CardTitle tag="h4">
                                    <a
                                      href="#pablo"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Blue Card
                                    </a>
                                  </CardTitle>
                                  <p className="card-description">
                                    What all of these have in common is that
                                    they're pulling information out of the app
                                    or the service and making it relevant to the
                                    moment.
                                  </p>
                                </CardBody>
                              </Card>
                              {/* end card */}
                            </div>
                          </Col>
                          <Col md="4" sm="6">
                            <div className="card-big-shadow">
                              <Card
                                className="card-just-text"
                                data-background="color"
                                data-color="green"
                                data-radius="none"
                              >
                                <CardBody>
                                  <h6 className="card-category">Best cards</h6>
                                  <CardTitle tag="h4">
                                    <a
                                      href="#pablo"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Green Card
                                    </a>
                                  </CardTitle>
                                  <p className="card-description">
                                    What all of these have in common is that
                                    they're pulling information out of the app
                                    or the service and making it relevant to the
                                    moment.
                                  </p>
                                </CardBody>
                              </Card>
                              {/* end card */}
                            </div>
                          </Col>
                          <Col md="4" sm="6">
                            <div className="card-big-shadow">
                              <Card
                                className="card-just-text"
                                data-background="color"
                                data-color="yellow"
                                data-radius="none"
                              >
                                <CardBody>
                                  <h6 className="card-category">Best cards</h6>
                                  <CardTitle tag="h4">
                                    <a
                                      href="#pablo"
                                      onClick={(e) => e.preventDefault()}
                                    >
                                      Yellow Card
                                    </a>
                                  </CardTitle>
                                  <p className="card-description">
                                    What all of these have in common is that
                                    they're pulling information out of the app
                                    or the service and making it relevant to the
                                    moment.
                                  </p>
                                </CardBody>
                              </Card>
                              {/* end card */}
                            </div>
                          </Col>
                        </Row>
                      </CarouselItem>
                    );
                  })}
                  <a
                    className="left carousel-control carousel-control-prev"
                    data-slide="prev"
                    href="#pablo"
                    onClick={(e) => {
                      e.preventDefault();
                      previous();
                    }}
                    role="button"
                  >
                    <span className="fa fa-angle-left" />
                    <span className="sr-only">Previous</span>
                  </a>
                  <a
                    className="right carousel-control carousel-control-next"
                    data-slide="next"
                    href="#pablo"
                    onClick={(e) => {
                      e.preventDefault();
                      next();
                    }}
                    role="button"
                  >
                    <span className="fa fa-angle-right" />
                    <span className="sr-only">Next</span>
                  </a>
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default RecentUpdates;
